import { H1 } from "../../components/Text/Text";
import CreateNewBrandShortBody from "./CreateNewBrandShortBody";
import CreateNewBrandShortFooter from "./CreateNewBrandShortFooter";

import styles from './createNewBrandShort.module.scss';

export default {
    header: <H1>Create new brand</H1>,
    body: <CreateNewBrandShortBody />,
    footer: <CreateNewBrandShortFooter />,
    className: styles.wrapper,
}

export const CreateNewBrandShortWithName = (brandName: string) => ({
    header: <H1>Create new brand</H1>,
    body: <CreateNewBrandShortBody brandName={brandName}/>,
    footer: <CreateNewBrandShortFooter />,
    className: styles.wrapper,
});